import { render, staticRenderFns } from "./IssuesForTrial.vue?vue&type=template&id=282dd94e"
import script from "./IssuesForTrial.vue?vue&type=script&lang=ts"
export * from "./IssuesForTrial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports